import { ColoredLayout } from '@hg/stylizator/components'
import * as React from 'react'
import { osName } from 'react-device-detect'

import { IAttributes } from './Attributes'

const ColoredBackgroundLayoutComponent: React.FC<React.PropsWithChildren<IAttributes>> = (props) => {
  return (
    <ColoredLayout width={osName.toLowerCase().includes('android') ? 'narrow' : props.width}>
      {props.children}
    </ColoredLayout>
  )
}

export default ColoredBackgroundLayoutComponent
